import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-ext";
var AccessoriesView = /** @class */ (function (_super) {
    tslib_1.__extends(AccessoriesView, _super);
    function AccessoriesView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccessoriesView.prototype.mounted = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.$state.disableAccessories) {
                    this.$router.push("/summary");
                }
                return [2 /*return*/];
            });
        });
    };
    AccessoriesView = tslib_1.__decorate([
        Component
    ], AccessoriesView);
    return AccessoriesView;
}(Vue));
export default AccessoriesView;
